export enum MissingComplianceDetailsModalStateId {
  MissingCompanyDetails = 'missingCompanyDetails',
  MissingCustomerDetails = 'missingCustomerDetails',
}
